import type { HeroBlockModel } from '@site/shared'
import { LocaleLink as Link } from '@/components/LocaleLink'
import { analytics } from '@/lib/analytics'
import { useContactEmail } from '@/lib/useContactEmail'
import { useTranslation } from '@/lib/i18n/LocaleContext'

/**
 * Page hero: headline, sub-headline, one CTA and an optional image. Content is
 * owned by the page (home → hero block in Payload); the i18n strings are only
 * the fallback rendered before the CMS has any content.
 */
export function HeroSection({ block }: { block?: HeroBlockModel }) {
  const { t } = useTranslation()
  const { mailto, onCtaClick } = useContactEmail()
  const headline = block?.headline || t.hero.headline
  const subheadline = block?.subheadline ?? t.hero.subheadline
  const ctaLabel = block?.ctaLabel ?? t.hero.ctaLabel
  const ctaHref = block?.ctaHref ?? mailto()
  const image = block?.image

  return (
    <section className="block hero">
      <div className="wrap hero-grid">
        <div>
          <h1 className="h1">{headline}</h1>
          {subheadline && <p className="lede">{subheadline}</p>}
          {ctaHref && (
            <p className="hero-ctas">
              {ctaHref.startsWith('/') ? (
                <Link to={ctaHref} className="btn btn-primary" onClick={() => analytics.ctaClick(ctaLabel, ctaHref)}>{ctaLabel}</Link>
              ) : (
                <a
                  href={ctaHref}
                  className="btn btn-primary"
                  onClick={() => { analytics.ctaClick(ctaLabel, ctaHref); if (ctaHref.startsWith('mailto:')) onCtaClick() }}
                >
                  {ctaLabel}
                </a>
              )}
            </p>
          )}
        </div>
        {image && (
          <div className="hero-image">
            <img src={image.url} alt={image.alt} width={image.width} height={image.height} loading="eager" fetchPriority="high" />
          </div>
        )}
      </div>
    </section>
  )
}
